import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import RelativeLink from "../common/RelativeLink";
import TabNav from "../common/TabNav";
import { Popup } from 'semantic-ui-react';

const SimpleTopNav = ({ disabled }) => {
	const items = [
		{ text: "Elitesporters", url: "/sporteroverzicht" },
		{ text: "Historische lijst elitesporters", url: "/historischesporteroverzicht" },
		{ text: "Kampioenschappen", url: "/kampioenschapoverzicht" }
		// ,{ text: "Elitesporters koppelen", url: "/sporterkoppelen" }
	];

	const makeNavItem = (item, index) => {
		const navItemClassName = {
			"c-anchor-nav__item": true,
			["item--green"]: true,
			"c-anchor-nav__item--disabled": disabled ? false : disabled
		};

		const relativeLink = disabled ? <div className="ui-tab disabled-nav"><b>{item.text}</b></div> :
			<div>
				<RelativeLink to={item.url} className="ui-tab">
					<b>{item.text}</b>
				</RelativeLink>
			</div>;

		return (<div key={`simpleNavItem_${index}`} className={classnames(navItemClassName)}>
			{relativeLink}
		</div>);
	};

	const makeNadoNav = (item, index) => {
		return <li className="c-nav__item">
			<RelativeLink to={item.url} className="c-nav__link ">
				{item.text}
			</RelativeLink>
		</li>;
	};

	return (
		<nav className="c-header__nav-container ">
			<ul className="c-nav c-header__nav">
				{items.map((item, i) => makeNadoNav(item, i))}
			</ul>
		</nav>
	);
};

SimpleTopNav.propTypes = {
	disabled: PropTypes.bool
};

export default SimpleTopNav;